import Cookies from "js-cookie";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";
import { SidebarProvider } from "@/components/ui/sidebar";
import SkipToMain from "@/components/skip-to-main";
import { Spinner } from "@/components/ui/spinner";
import { Header } from "./header";
import { ApplicantProcessingSidebar } from "./applicant-processing-sidebar";

function RouteFallback() {
  return (
    <div className="flex h-full min-h-64 items-center justify-center">
      <Spinner className="h-8 w-8" />
    </div>
  );
}

interface Props {
  children?: React.ReactNode;
}

export function ApplicantProcessingLayout({ children }: Props) {
  const defaultOpen = Cookies.get("sidebar_state") !== "false";
  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <SkipToMain />
      <ApplicantProcessingSidebar />
      <div
        id="content"
        className={cn(
          "ml-auto w-full max-w-full",
          "peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon))]",
          "peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]",
          "sm:transition-[width] sm:duration-200 sm:ease-linear",
          "flex h-svh flex-col",
          "group-data-[scroll-locked=1]/body:h-full",
          "has-[main.fixed-main]:group-data-[scroll-locked=1]/body:h-svh",
        )}
      >
        <Header />
        <div className="p-4">
          <Suspense fallback={<RouteFallback />}>
            {children ? children : <Outlet />}
          </Suspense>
        </div>
      </div>
    </SidebarProvider>
  );
}
